function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3347 18.8653L10.9269 10.8764L7.51949 14.2839L7.9035 17.2888C7.91184 17.3529 7.90313 17.4182 7.87825 17.4781C7.85337 17.538 7.8132 17.5903 7.76177 17.6299L6.67879 18.7129C6.60053 18.7911 6.58597 18.7938 6.53267 18.6702L5.02301 15.1816L1.5344 13.6719C1.41079 13.6186 1.41348 13.6041 1.49173 13.5258L2.57472 12.4428C2.61448 12.3907 2.66733 12.3501 2.72785 12.3251C2.78836 12.3001 2.85437 12.2915 2.9191 12.3004L5.92404 12.6844L9.3315 9.27697L1.34256 4.86925C1.05247 4.7118 1.05387 4.67739 1.19845 4.53282L2.33847 3.3928C2.51554 3.21572 2.6607 3.10357 3.04489 3.19861L12.7184 5.89007L17.1737 1.43477C17.3863 1.22212 17.6744 1.10227 17.9744 1.10157C18.2744 1.10087 18.5619 1.21938 18.7736 1.43104C18.9852 1.6427 19.1037 1.93016 19.103 2.23019C19.1023 2.53022 18.9825 2.81824 18.7698 3.03089L14.3145 7.48619L17.006 17.1597C17.101 17.5439 16.9889 17.689 16.8118 17.8661L15.6698 19.0081C15.5265 19.154 15.4941 19.1534 15.3347 18.8653Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAirplane);
export default __webpack_public_path__ + "static/media/icon-airplane.e44b3fe1cd1befced06de30c34c9b010.svg";
export { ForwardRef as ReactComponent };